import { render, staticRenderFns } from "./orderSite.vue?vue&type=template&id=ff610d26&scoped=true&"
import script from "./orderSite.vue?vue&type=script&lang=js&"
export * from "./orderSite.vue?vue&type=script&lang=js&"
import style0 from "./orderSite.vue?vue&type=style&index=0&id=ff610d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff610d26",
  null
  
)

export default component.exports